import { Component, OnInit, Input } from '@angular/core';
import { AbstractModel } from '../models/abstract.model';

@Component({
  selector: 'app-table-detail-abstract',
  templateUrl: './table-detail-abstract.component.html',
  styleUrls: ['./table-detail-abstract.component.scss']
})
export class TableDetailAbstractComponent implements OnInit {

  @Input() data: AbstractModel;

  constructor() { }

  ngOnInit(): void {
  }

}
